export default __webpack_public_path__ + "static/media/Resources.08ae7db6.svg";